import getFontClass from '../../utils/getFontClass';
import button from '../helpers/Button';

const extractHeading = (headings) => {
  let text = '';
  headings.forEach((heading) => {
    text += `<span class="${getFontClass(heading.heading_size)}">${heading.heading_text}</span>`;
  });
  return text;
};

const extractSubheading = (subheadings) => {
  let text = '';
  subheadings.forEach((subheading) => {
    text += `<span>${subheading.sub_heading_text}</span>`;
  });
  return text;
};

const extractSocials = (socials) => {
  let text = '';
  socials.forEach((social) => {
    switch (social.social_platform) {
      case 'facebook':
        text += `<a class="Module-HeroBanner__Share--Icon" href="//www.facebook.com/sharer.php?u=${window.location.href}"><i class="fab fa-facebook-f"></i></a>`;
        break;
      case 'twitter':
        text += `<a class="Module-HeroBanner__Share--Icon" href="//twitter.com/share?text=&url=${window.location.href}"><i class="fab fa-twitter"></i></a>`;
        break;
      case 'pinterest':
        text += `<a class="Module-HeroBanner__Share--Icon" href="//pinterest.com/pin/create/button/?url=${window.location.href}"><i class="fab fa-pinterest-p"></i></a>`;
        break;
      default:
        break;
    }
  });
  return text;
};

const articleInfo = (settings) => {
  return settings.is_article
    ? `
      <div class="Module-HeroBanner__article-info-container">
        <div class="Module-HeroBanner__blog-name">
          ${settings.blog_name}
        </div>
        <div class="Module-HeroBanner__article-info">
          ${settings.publish_date} | by <h3 class="AuthorName">${settings.author_name}</h3>
        </div>
      </div>
    `
    : '';
};

export default (settings, module_name, index) => {
  const heading = extractHeading(settings.heading || []);
  const subheading = extractSubheading(settings.sub_heading || []);
  const socials = extractSocials(settings.social_sharing || []);
  const article_info = articleInfo(settings);

  const content_html = `
  <h1 class="Module-HeroBanner__Heading">
    ${heading}
  </h1>
  <h2 class="Module-HeroBanner__Subheading p">
    ${subheading}
  </h2>
  <div class="Module-HeroBanner__ArticleInfo">
    ${article_info}
  </div>
  <div class="Module-HeroBanner__Socials">
    ${socials}
  </div>
  <div class="Module-HeroBanner__Content">
    ${settings.content}
  </div>
  ${button(settings.buttons || [], module_name, index)}
  `;
  return content_html;
};
